import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

export const useArticleLimitCheck = () => {
  const { getConfig, isFetched } = useSubscription();
  const { toggleModal } = useModalStore();

  // Generic so callers can recover the return value of `action` — notably the
  // Promise returned by async callbacks. `useImportUrl.executeImport` needs
  // to `await` the mutation inside the callback to get back the real article
  // result; previously the hook discarded that promise and `executeImport`
  // always resolved to `null` (reporting every successful scrape as a failure
  // to the caller). Sync callers that ignore the return value are unaffected.
  const handleArticleLimitCheck = <T>(action: () => T): T | undefined => {
    // Source of truth is the backend `can_add_article` flag (computed
    // server-side from articles_limit minus current saved articles). The
    // older client-side count via the articlesInfinite cache key never
    // worked because that key is paginated, so it always returned 0 and
    // the modal never fired.
    const canAdd = getConfig('can_add_article') as boolean | undefined;
    if (isFetched && canAdd === false) {
      toggleModal(MODAL_NAMES.ARTICLE_LIMIT_MODAL);
      return undefined;
    }
    return action();
  };

  return handleArticleLimitCheck;
};
